import Zergling from "../../../../../helpers/zergling";

export const calculateBetBuilderPossibleWin = (stake, price, currencyConfig) => {
    if (!stake) return null;
    const rounding = Math.abs(currencyConfig.rounding);
    const amount = stake * price;
    return parseFloat(amount.toFixed(rounding));
};

export const betBuilderPlaceBet = (bestlipUid, stake) => Zergling.get({
    name: "CreateBetSC",
    params: {
        BetSlipUid: bestlipUid,
        Amount: stake
    },
}, 'betshop_command');